import React from 'react'
import {Lang} from 'yougile-lang'
import {Icon} from '../common/base/icon'

export const EmptyRowsPlaceholder = () => {
  return (
    <div className="flex flex-col items-center justify-center h-[248px] w-full">
      <Icon icon="IconCustomSearch" size={20} className="mb-8"></Icon>
      <div className="text-sm-semibold text-secondary mb-4">
        {Lang.msg.crm.activitiesView.emptyRowsPlaceholder.title}
      </div>
      <div className="text-xs-bold text-secondary text-center">
        {Lang.msg.crm.activitiesView.emptyRowsPlaceholder.subtitle}
      </div>
    </div>
  )
}
